/* eslint-disable camelcase */
import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from 'src/api/axiosBaseQuery'
import { API_BASE_PATH } from 'src/utils/constants'
import {
  PaginationPayload,
  ParkDetailsResponse,
  ParksListResponse,
  UpdateParkPayload,
} from './types'

const API_ENDPOINT = '/api/v1/fitness'

const manageParksApi = createApi({
  reducerPath: 'manageParksApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosBaseQuery({
    baseUrl: API_BASE_PATH,
  }),
  tagTypes: ['manageParksApi'],
  endpoints: (builder) => ({
    getParksList: builder.query<ParksListResponse, PaginationPayload>({
      query: ({ page = 1, pageSize = 10, sortBy = '', search = '' }) => ({
        url: `${API_ENDPOINT}/admin_parks_list/?q=${search}&page=${page}&page_size=${pageSize}${
          sortBy ? `&sort_by=${sortBy}` : ''
        }`,
        method: 'GET',
      }),
      transformResponse: (response: ParksListResponse) => {
        return response
      },
    }),

    getParkById: builder.query<ParkDetailsResponse, number>({
      query: (id) => ({
        url: `${API_ENDPOINT}/admin_park/${id}/`,
        method: 'GET',
      }),
      transformResponse: (response: ParkDetailsResponse) => {
        return response
      },
    }),

    addPark: builder.mutation<void, FormData>({
      query: (data) => ({
        url: `${API_ENDPOINT}/admin_park/`,
        method: 'POST',
        data: data,
      }),
    }),

    deletePark: builder.mutation<void, number>({
      query: (id) => ({
        url: `${API_ENDPOINT}/admin_park/${id}/`,
        method: 'DELETE',
      }),
    }),

    updatePark: builder.mutation<void, UpdateParkPayload>({
      query: ({ data, id }) => ({
        url: `${API_ENDPOINT}/admin_park/${id}/`,
        method: 'PATCH',
        data: data,
      }),
    }),
  }),
})

export const {
  useGetParksListQuery,
  useAddParkMutation,
  useDeleteParkMutation,
  useGetParkByIdQuery,
  useUpdateParkMutation,
} = manageParksApi
export default manageParksApi
